export async function tryOrDefault<T> (promise: Promise<T>, defaultValue: T, onError?: (err: Error) => void) {
  try {
    return await promise
  } catch (err) {
    if (onError) onError(err)
    return defaultValue
  }
}
